import { useEffect, useState } from "react";
import useGlobalContext from "../../../hooks/useGlobalContext";
import Scheduler from "react-mui-scheduler";
import { getDefaultCalendarOptions } from "../../../common/EntitiesManagement";
import EventSummary from "./EventSummary";
import ModalBackground from "../../../components/common/ModalBackground";
import localize from "../../../common/localize";
import { GetDateInYYYYMMDDFormatWithSeparator } from "../../../common/utils";

export default function CalendarView() {
  const { eventsData } = useGlobalContext();
  const [calendarOptions, setCalendarOptions] = useState(
    getDefaultCalendarOptions()
  );
  const [events, setEvents] = useState([]);
  const [showEventSummary, setShowEventSummary] = useState(false);
  const [eventModel, setEventModel] = useState();

  const generateCalendarEvent = (event, expectedSolutionDate) => ({
    id: event.Id,
    label: eventCodeComponent(event.Code, event.EventType?.ForegroundColor),
    groupLabel: event.EventType.Name,
    user: event.ReporterName,
    color: event?.EventType?.BackgroundColor,
    startHour: "08:00 AM",
    endHour: "17:00 PM",
    date: expectedSolutionDate,
    createdAt: new Date(),
    createdBy: event.CreatedBy,
  });

  const eventCodeComponent = (code, fontColor) => {
    return (
      <div>
        <label style={{ color: fontColor ?? "white" }}>{code}</label>
      </div>
    );
  };

  useEffect(() => {
    if (eventsData.Data) {
      const eventsFiltered = eventsData.Data.filter(
        (element) =>
          element.OperationalStatus == 1 || element.OperationalStatus == 2
      );

      if (eventsFiltered && eventsFiltered.length > 0) {
        const eventsToShow = [];

        eventsFiltered.forEach((element) => {
          const timestamp =
            new Date(element.ExpectedSolutionFinalDate).getTime() -
            new Date(element.ExpectedSolutionDate).getTime();

          const diffDays = timestamp / (1000 * 60 * 60 * 24);
          if (diffDays <= 0) {
            eventsToShow.push(
              generateCalendarEvent(
                element,
                GetDateInYYYYMMDDFormatWithSeparator(
                  new Date(element.ExpectedSolutionDate),
                  "-"
                )
              )
            );
          } else {
            let countOfDays = 0;
            do {
              const rawDate = new Date(element.ExpectedSolutionDate);
              const expectedSolutionDate = GetDateInYYYYMMDDFormatWithSeparator(
                rawDate.setDate(rawDate.getDate() + countOfDays),
                "-"
              );
              eventsToShow.push(
                generateCalendarEvent(element, expectedSolutionDate)
              );
              countOfDays += 1;
            } while (countOfDays <= diffDays);
          }
        });
        setEvents(eventsToShow);
        return;
      }
    }

    setEvents([]);
  }, [eventsData.Data]);

  const handleCellClick = (event, row, day) => {
    // Do something...
  };

  const handleEventClick = (event, item) => {
    const eventToShow = eventsData.Data.find(
      (element) => element.Id === item.id
    );
    if (eventToShow) {
      setEventModel(eventToShow);
      setShowEventSummary(true);
    }
  };

  const handleEventsChange = (item) => {
    // Do something...
  };

  const handleAlertCloseButtonClicked = (item) => {
    // Do something...
  };

  return (
    <div>
      {showEventSummary && (
        <ModalBackground
          showModal={showEventSummary}
          setShowModal={setShowEventSummary}
          title={localize.event_summary}
          okButtonText={localize.view_details}
          onClickToSubmit={() => {
            setShowEventSummary(false);
            window.open(`/events/detail/${eventModel.Id}`, "_blank");
          }}
          cancelButtonText={localize.close}
          onClickToCancel={() => {
            setShowEventSummary(false);
          }}
          Component={<EventSummary eventInfo={eventModel} />}
        />
      )}

      <Scheduler
        locale="es"
        events={events}
        legacyStyle={false}
        options={calendarOptions?.options}
        alertProps={calendarOptions?.alertProps}
        toolbarProps={calendarOptions?.toolbarProps}
        onEventsChange={handleEventsChange}
        onCellClick={handleCellClick}
        onTaskClick={handleEventClick}
        onAlertCloseButtonClicked={handleAlertCloseButtonClicked}
      />
    </div>
  );
}
